import { createSlice } from '@reduxjs/toolkit';

const globalRenderingInfo = createSlice({
  name: 'globalRenderingInfo',
  initialState: {
    data: null,
  },
  reducers: {
    setGlobalRenderingInfo: (state, { payload }) => {
      state.data = payload;
    },
  },
});

export const { setGlobalRenderingInfo } = globalRenderingInfo.actions;
export const globalRenderingInfoSelector = (state) => state.globalRenderingInfo;
export const globalRenderingInfoReducer = globalRenderingInfo.reducer;
export default globalRenderingInfoReducer;

export const selectGlobalRenderingInfoData = (state) => state.globalRenderingInfo.data
export const selectDpiOptions = (state) => {
  const dpiArr = state.globalRenderingInfo.data?.rendering_info?.dpi;
  if (!state.globalRenderingInfo.data?.rendering_info?.dpi) return [];
  return dpiArr.map(value => ({
    value,
    label: `${value} DPI`,
  }))
}
export const selectDefaultDpi = (state) => state.globalRenderingInfo.data?.rendering_info?.default_dpi;

// {
//   "rendering_info": {
//       "dpi": [
//           600,
//           300,
//           250,
//           150,
//           96,
//           72
//       ],
//       "default_dpi": 600
//   },
//   "render_max_width_limit": 0,
//   "render_max_height_limit": 0
// }